import { render, staticRenderFns } from "./BannerHighlightCreate.vue?vue&type=template&id=73086460&"
import script from "./BannerHighlightCreate.vue?vue&type=script&lang=js&"
export * from "./BannerHighlightCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports